module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("homeView.permit")))]), _vm._v(" "), _vm._l((_vm.store.globalSettings.permissionText ? _vm.store.globalSettings.permissionText.split('\n') : ''), function(paragraph, i) {
    return _c('p', {
      key: i,
      staticClass: "about"
    }, [_vm._v("\r\n        " + _vm._s(paragraph)), _c('br')])
  }), _vm._v(" "), _c('button', {
    staticClass: "button button-green",
    on: {
      "click": _vm.backToHome
    }
  }, [_vm._v(_vm._s(_vm.$t("permissionView.backToHome")))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-001c46c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/PermissionView.vue
// module id = 106
// module chunks = 0